import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, Link } from '@/shared/ui';
import Typography from '@/shared/ui/typography/Text';

import type { Sx } from '@/shared/types/uiTypes';

import type { MonthlyRecapsArticle } from '@/features/monthly-recaps';

type MonthlyRecapsArticleTeaserVariant = 'row' | 'single';

type MonthlyRecapsArticleTeaserProps = {
  article: MonthlyRecapsArticle;
  onClick: () => void;
  variant?: MonthlyRecapsArticleTeaserVariant;
};

const DESCRIPTION_CHAR_LIMIT = 240;

const truncateDescription = (description: string): string =>
  description.length > DESCRIPTION_CHAR_LIMIT
    ? `${description.slice(0, DESCRIPTION_CHAR_LIMIT)}...`
    : description;

const teaserSx = (variant: MonthlyRecapsArticleTeaserVariant): Sx => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '4px',
  width: '100%',
  textAlign: 'left',
  ...(variant === 'row' ? { backgroundColor: 'gx.tileLight', p: '8px' } : { px: 2, pb: 2 })
});

const headlineSx: Sx = { fontWeight: 'bold', mb: 1 };

const dateSx: Sx = {
  fontWeight: 500,
  color: 'gx.subtext'
};

export const MonthlyRecapsArticleTeaser = ({
  article,
  onClick,
  variant = 'row'
}: MonthlyRecapsArticleTeaserProps) => (
  <Box sx={teaserSx(variant)}>
    <Typography
      size={variant === 'single' ? 24 : 14}
      sx={headlineSx}
    >
      {article.headline}
    </Typography>
    <Typography size={variant === 'single' ? 16 : 14}>
      {variant === 'single' ? article.description : truncateDescription(article.description)}{' '}
      <Link
        color='primary'
        component='button'
        sx={{
          fontSize: 14,
          textDecoration: 'none',
          verticalAlign: 'baseline',
          display: 'inline-flex',
          alignItems: 'center'
        }}
        onClick={onClick}
      >
        Read full article
        <ChevronRightIcon sx={{ fontSize: '1em' }} />
      </Link>
    </Typography>

    <Typography
      size={12}
      sx={dateSx}
    >
      Date: {article.date}
    </Typography>
  </Box>
);
